import angular from 'angular';

function removePrefix() {
    return function (item, prefix) {
        prefix = prefix + " "; //add white space to prefix to trim from database EWWW! string.trim() aproach won´t work
        item = item.replace(prefix, "");
        return item;
    };
}

const removePrefixFilter = angular.module('st.filters.removePrefix', [])
    .filter('removePrefix', removePrefix)
    .name;

export default removePrefixFilter;


// WEBPACK FOOTER //
// ./client/app/common/filters/removePrefix.js